import { z } from "zod/v4";

export const temporalInstantSchema = z.instanceof(Temporal.Instant);

export const temporalPlainDateSchema = z.instanceof(Temporal.PlainDate);

export const temporalPlainTimeSchema = z.instanceof(Temporal.PlainTime);

export const timeZoneSchema = z
  .string()
  .min(1)
  .refine(
    (timeZone) => {
      try {
        Temporal.Now.zonedDateTimeISO(timeZone);
        return true;
      } catch {
        return false;
      }
    },
    { message: "Invalid time zone" },
  );
